export function LoadingState({ rows = 6 }: { rows?: number }) {
  return <div className="profile-grid" aria-label="Loading profiles">
    {Array.from({ length: rows }, (_, index) => <div className="skeleton-card" key={index}><div/><span/><span/></div>)}
  </div>;
}
